import type { GlobalApiAccountAccess } from '@data/account-access';
import type { GlobalApiPaymentDetails } from '@data/global-api-payments';

export const getStatus = (
  subject: GlobalApiAccountAccess | GlobalApiPaymentDetails | null | undefined
) => {
  if (subject && 'paymentInitiationFlow' in subject) {
    return subject.status;
  }

  if (subject && 'accountAccessFlow' in subject) {
    return subject.status.status;
  }

  throw new Error('Invalid subject');
};
